import { Button } from '@components/ui/button'
import { BadgePercent } from 'lucide-react'
import { FC } from 'react'

const CouponDisplay: FC<{
  description: string
  code: string
  onApply: () => void
  applied?: boolean
}> = ({ code, description, onApply, applied = false }) => {
  return (
    <div className="flex justify-between p-3  items-center">
      <div className="flex gap-3 items-center">
        <div className=" h-full flex">
          <BadgePercent className=" text-primary-500 h-full" size={50} />
        </div>
        <div className="text-neutral-800">
          <div className=" heading_small">{description}</div>
          <div className="text-sm font-normal"> {code}</div>
          {applied ? (
            <div className="text-sm text-green-600 font-medium">Coupon code applied!</div>
          ) : undefined}
        </div>
      </div>
      <div>
        {applied ? (
          <div className=" cursor-pointer" onClick={onApply}>
            remove
          </div>
        ) : (
          <Button
            variant={'outline'}
            className=" text-primary-500 border-primary-500 hover:text-primary-500 hover:bg-primary-100"
            onClick={onApply}
          >
            Apply
          </Button>
        )}
      </div>
    </div>
  )
}

export default CouponDisplay
